import { ViewPages } from '..'
import { HttpServiceResponse } from '../../shared'
import { ApplicationViewParams } from '../models/view/view-params.model'
import AbstractApplicationProvider from './application-abstract.provider'

export class ViewProvider extends AbstractApplicationProvider {
  urlPath = 'application_view_api'

  public view<T = any>(page: ViewPages, params: ApplicationViewParams): Promise<HttpServiceResponse<T>> {
    const query = this.query.stringify({
      page,
      ...params,
    })

    return this.http.get(`${this.url}?${query}`)
  }
}
